import { BellRing, CreditCard, Repeat } from "lucide-react";
import { defineModuleUi, useOrg } from "@vixio/data";
import { formatInt, formatMoney, lazyPage } from "@vixio/ui";
import { SubscriptionsPage, useMrr } from "./SubscriptionsPage";

export * from "./api";

// Telas carregadas sob demanda: cada uma vira um arquivo à parte no build.
const ChargesPage = lazyPage(() => import("./ChargesPage"), "ChargesPage");
const RemindersPage = lazyPage(() => import("./RemindersPage"), "RemindersPage");

function MrrWidget() {
  const org = useOrg();
  const m = useMrr(org.id).data;
  return (
    <div>
      <p className="num" style={{ fontSize: "var(--fs-20)", fontWeight: 600 }}>
        {formatMoney(m?.mrr ?? 0)}
      </p>
      <p className="text-2">{formatInt(m?.active ?? 0)} assinatura(s) ativa(s)</p>
    </div>
  );
}

export default defineModuleUi({
  key: "billing",
  title: "Cobrança",
  domain: "money",
  icon: Repeat,
  menu: [
    { path: "/dinheiro/assinaturas", label: "Assinaturas", minRole: "manager", icon: Repeat, order: 50, keywords: "mrr recorrente planos ciclo" },
    { path: "/dinheiro/cobrancas", label: "Cobranças", minRole: "manager", icon: CreditCard, order: 55, keywords: "boleto pix cartão asaas" },
    { path: "/dinheiro/lembretes", label: "Lembretes de vencimento", minRole: "manager", icon: BellRing, order: 56, keywords: "aviso vencimento lembrete boleto cliente" },
  ],
  routes: [
    { path: "/dinheiro/assinaturas", element: <SubscriptionsPage />, minRole: "manager" },
    { path: "/dinheiro/cobrancas", element: <ChargesPage />, minRole: "manager" },
    { path: "/dinheiro/lembretes", element: <RemindersPage />, minRole: "manager" },
  ],
  widgets: [{ key: "billing.mrr", title: "Receita recorrente (MRR)", minRole: "manager", span: 1, order: 30, element: MrrWidget }],
});
